import "../../css/inner-page/sectionTips.scss";
import CTA from "../CTA";

export default function Section(props) {
  return (
    <section id="tips">
      <h2 data-aos="fade" dangerouslySetInnerHTML={{ __html: props.title }}></h2>
      <div className="tip-wrapper">
        <div className="tip-header">
          <div className="content">
            <span>{props.pre_subtitle}</span>
            <h3>{props.subtitle}</h3>
          </div>
          <CTA href={props.cta.url} title={props.cta.title} segmentLocation="Marketing Strategies" />
        </div>
        <div className="tip-content">
          <div className="img-wrapper" data-aos="fade-up">
            <img src={props.image_group["1x"]} alt={props.image_group.alt} />
          </div>
          <div className="tips-content-wrapper">
            <span className="tips-title">You'll learn how to:</span>
            <div className="tips-wrapper">
              {props.tips.map((item, index) => {
                return (
                  <div key={index} className="tip">
                    <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                    <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
